<template>
  <v-container fluid>
    <main-header-plat-a-pat />
    <main-header-plat-b :navBItems="schema.navBItems" />
    <v-overlay-loader />
    <v-row class="mx-auto">
      <v-menu-pat
        :input.sync="input"
        :dialogItem="schema.dialogItem"
        :recordHCP="recordHCP"
        :recordProfes="recordProfes"
        :saveTransfer="saveTransfer"
        :updateInput="updateInput"
        :updateInputProfes="updateInputProfes"
        :recordTransfers="recordTransfers"
        :codeTransfer="codeTransfer"
      />
    </v-row>
    <v-overlay
      v-model="overlayCode"
      class="d-flex align-star justify-center"
      style="z-index: 1000; position: absolute"
    >
      <v-row class="d-flex justify-center my-5">
        <v-card min-height="200" width="60%" class="secundary6">
          <v-card-title class="text-body-1 font-weight-bold justify-center">
            Código de Transferencia
          </v-card-title>
          <v-card-text class="text-body-2">
            Este es el código que permitirá transferir los permisos de las Historias Clínicas.
            <br />
            Para completar la transferencia entregue este código al profesional de la salud mental
            elegido.
            <v-text-field class="mx-10" v-model="codeTransfer"></v-text-field>
          </v-card-text>
          <v-card-actions class="mx-auto mb-5">
            <v-btn color="primary" class="d-flex mx-auto justify-center" @click="toggleOverlay()">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-row>
    </v-overlay>
    <v-overlay v-model="overlayProgress" style="z-index: 1000; position: absolute">
      <v-row class="mt-15 ml-3" style="width: 200px">
        <v-col cols="12" class="ma-0 pa-0 mt-15">
          <span class="d-flex text-subtitle-1 justify-center text-black mt-15">Procesando</span>
        </v-col>
        <v-col cols="12">
          <v-progress-linear class="mx-auto" indeterminate rounded height="7"></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
    <v-snack-bar :snackbar="snackbar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatAPat from '@/components/includes/MainHeaderPlatAPat.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VMenuPat from '@/components/base/VMenuPat.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'PatRecordAPage',
  components: {
    MainHeaderPlatAPat,
    MainHeaderPlatB,
    VOverlayLoader,
    VMenuPat,
    VSnackBar,
  },

  data() {
    return {
      overlayCode: false,
      overlayProgress: false,
      input: [],
    };
  },



  mounted() {
    this.loadData()
  },

  computed: {
    ...mapGetters('patRecordAPage', [
      'schema',
      'recordHCP',
      'recordProfes',
      'recordTransfers',
      'codeTransfer',
      'status',
    ]),
    ...mapGetters('notifications', ['snackbar']),
  },

  methods: {
    ...mapActions('patRecordAPage', [
      'loadSchema',
      'loadRecordHCP',
      'loadRecordProfes',
      'loadRecordTransfers',
      'saveTransfer',
    ]),
    ...mapActions('notifications', ['triggerSnackbar']),

    async loadData() {
      try {
        this.overlayProgress = true;
        await Promise.all([
          this.loadSchema(),
          this.loadRecordHCP(),
          this.loadRecordProfes(),
          this.loadRecordTransfers(),
        ]); 
        this.overlayProgress = false;  
      } catch (error) {
        this.overlayProgress = false;
        this.handleDataError(error, 'Error al cargar datos.');
      }
    },

    handleEvents() {},

    updateInput(modelRecordHCPInput) {
      this.modelRecordHCPInput = modelRecordHCPInput;
    },

    updateInputProfes(modelRecordProfesInput) {
      this.modelRecordProfesInput = modelRecordProfesInput;
    },

    async saveTransfer() {
      this.overlayProgress = true;
      let recordHCP = this.recordHCP;
      let modelRecordHCPInputPre = this.input;
      const modelRecordProfesInput = this.modelRecordProfesInput;

      let recordHCPNum = [];
      for (let i = 0; i < recordHCP.length; i++) {
        if (parseInt(recordHCP[i].instProfes) === modelRecordProfesInput) {
          recordHCPNum.push(recordHCP[i].id);
        }
      }

      for (let i = 0; i < recordHCPNum.length; i++) {
        for (let n = 0; n < modelRecordHCPInputPre.length; n++) {
          if (
            recordHCPNum[i] <= modelRecordHCPInputPre[n] &&
            modelRecordHCPInputPre[n] <= recordHCPNum[i] + 27
          ) {
            delete modelRecordHCPInputPre[n];
          }
        }
      }

      let modelRecordHCPInput = modelRecordHCPInputPre.filter(el => el != null);

      let model = {};
      model.recordHCP = recordHCP;
      model.modelRecordHCPInput = modelRecordHCPInput;
      model.modelRecordProfesInput = modelRecordProfesInput;
      model.id = this.$store.state.authPat.authData.patientId;

      await this.$store.dispatch('patRecordAPage/saveTransfer', model).then(
        () => {
          this.reload();
          this.snackbarOpen();
          this.overlayProgress = false;

          if (this.codeTransfer === null) {
            this.snackbar.visible = true;
            this.snackbar.content = "Este profesional ya tiene los permisos de este HCP.";
          } else {
            this.overlayCode = true;
            this.overlayProgress = false;
            this.snackbar.visible = true;
            this.snackbar.content = "Correcto. En la ventana superior tendrá el código de transferencia.";
          }
        },
        () => {
          this.reload();
          this.snackbarOpen();
          this.overlayProgress = false;
        }
      );
    },

    toggleOverlay() {
      if (this.overlayCode === false) {
        this.overlayCode = true;
      } else {
        this.overlayCode = false;
      }
    },

    reload() {
      this.loadRecordHCP();
      this.loadRecordProfes();
      this.loadRecordTransfers();
      this.input = [];
    },

    snackbarOpen() {
      this.snackbar.visible = false;
      if (this.status === 'success') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
      } else if (this.status === 'error') {
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackError;
      }
    },
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 90px;
}

.contentRowCentral {
  width: 80%;
  min-height: 400px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}
</style>
